(function () {
  'use strict';

  var COLOR_MAP = {
    black: '#111827', silver: '#9ca3af', white: '#ffffff', brown: '#8b5e3c',
    burgundy: '#7f1d3a', yellow: '#f6cf3e', schoolbus: '#f2b10e', red: '#cf2f35',
    'dark blue': '#183d63', 'teal blue': '#16758a', 'sky blue': '#65b7df',
    'dark green': '#175c43', 'light green': '#61ad63', orange: '#ee7a28',
    pink: '#e8a0b7', purple: '#7755a6', clear: 'transparent', natural: '#c99b62',
    kraft: '#b88952', blue: '#28649a', green: '#29875a', gray: '#7a828b', grey: '#7a828b'
  };

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function parsePack(value) {
    var parts = String(value || '').split(/\s+-\s+/);
    if (parts.length < 2) return null;

    var specification = parts.shift().trim();
    var pack = parts.join(' - ').trim();
    if (!specification || !pack) return null;

    var rollMatch = pack.match(/\b(\d+)\s*(rolls?|units?|strips?|pieces?|pcs?)\b/i);
    var totalRollMatch = pack.match(/\((\d+)\s*rolls?\)/i);
    var unitCount = totalRollMatch ? Number(totalRollMatch[1]) : (rollMatch ? Number(rollMatch[1]) : null);
    var category = 'pack';

    if (/pallet/i.test(pack)) category = 'pallet';
    else if (unitCount === 1 && !/case|box|cs\b/i.test(pack)) category = 'single';
    else if (/case|box|cs\b|rolls?|units?|strips?|pieces?|pcs?/i.test(pack)) category = 'case';

    return {
      raw: String(value),
      specification: specification,
      pack: pack,
      category: category,
      unitCount: unitCount
    };
  }

  function money(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency', currency: 'USD', minimumFractionDigits: 2
    }).format((Number(cents) || 0) / 100);
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function setSelect(select, value) {
    if (select.value === value) return;
    select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function variantFor(root, selects, overrideSelect, overrideValue) {
    var data = root.querySelector('script[data-id="product-variants"]');
    if (!data) return null;
    try {
      var variants = JSON.parse(data.textContent);
      var chosen = selects.map(function (select) {
        return select === overrideSelect ? overrideValue : select.value;
      });
      return variants.find(function (variant) {
        return chosen.every(function (value, index) { return variant.options[index] === value; });
      }) || null;
    } catch (error) {
      return null;
    }
  }

  function addHeading(fieldset, title, selectedText) {
    var legend = element('legend', 'tt-picker__legend');
    legend.appendChild(element('span', 'tt-picker__label', title));
    if (selectedText) legend.appendChild(element('span', 'tt-picker__selected', selectedText));
    fieldset.appendChild(legend);
    return legend;
  }

  function renderColorPicker(select, optionName) {
    var fieldset = element('fieldset', 'tt-picker__group tt-picker__group--colors');
    var legend = addHeading(fieldset, optionName, select.value);
    var selectedLabel = legend.querySelector('.tt-picker__selected');
    var choices = element('div', 'tt-picker__swatches');

    Array.prototype.forEach.call(select.options, function (option) {
      var button = element('button', 'tt-swatch');
      var colorName = normalize(option.value);
      button.type = 'button';
      button.title = option.value;
      button.setAttribute('aria-label', option.value);
      button.style.setProperty('--tt-swatch-color', COLOR_MAP[colorName] || '#d7dee2');
      if (colorName === 'white' || colorName === 'clear') button.classList.add('tt-swatch--light');
      if (option.disabled) button.disabled = true;

      button.addEventListener('click', function () { setSelect(select, option.value); });
      choices.appendChild(button);
    });

    function sync() {
      selectedLabel.textContent = select.value;
      Array.prototype.forEach.call(choices.children, function (button, index) {
        var active = select.options[index].value === select.value;
        button.disabled = select.options[index].disabled;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    select.addEventListener('change', sync);
    sync();
    fieldset.appendChild(choices);
    return fieldset;
  }

  function renderButtonPicker(select, optionName) {
    var root = select.closest('variant-selects');
    var selects = Array.prototype.slice.call(root.querySelectorAll('select[name^="options["]'));
    var optionIndex = selects.indexOf(select);
    var data = root.querySelector('script[data-id="product-variants"]');
    var variants = [];
    try { variants = JSON.parse(data ? data.textContent : '[]'); } catch (error) {}
    var values = Array.prototype.map.call(select.options, function (option) { return option.value; });
    variants.forEach(function (variant) {
      var value = variant.options[optionIndex];
      if (value && values.indexOf(value) === -1) values.push(value);
    });
    var fieldset = element('fieldset', 'tt-picker__group');
    addHeading(fieldset, optionName);
    var choices = element('div', 'tt-picker__buttons');
    var note = element('p', 'tt-picker__availability-note');
    note.setAttribute('role', 'status');
    note.setAttribute('aria-live', 'polite');

    values.forEach(function (value) {
      var parsed = parsePack(value);
      var button = element('button', 'tt-choice');
      button.type = 'button';
      button.dataset.value = value;
      button.appendChild(element('span', 'tt-choice__main', parsed ? parsed.specification : value));
      if (parsed) button.appendChild(element('span', 'tt-choice__meta', parsed.pack));
      button.appendChild(element('span', 'tt-choice__availability'));
      button.addEventListener('click', function () {
        if (!button.disabled) setSelect(select, value);
      });
      choices.appendChild(button);
    });

    function sync() {
      var color = selects.find(function (item, index) {
        return index < optionIndex && /color|colour/i.test(item.name);
      });
      var unavailableCount = 0;
      Array.prototype.forEach.call(choices.children, function (button) {
        var value = button.dataset.value;
        var option = Array.prototype.find.call(select.options, function (item) {
          return item.value === value;
        });
        var matches = variants.filter(function (variant) {
          return variant.options[optionIndex] === value && selects.every(function (item, index) {
            return index >= optionIndex || variant.options[index] === item.value;
          });
        });
        var exists = variants.length ? matches.length > 0 : !!option;
        var available = exists && (variants.length ? matches.some(function (variant) {
          return variant.available;
        }) : !option.disabled);
        var message = available ? '' : (exists ? 'Sold out' : (color ? 'Unavailable in ' + color.value : 'Unavailable'));
        var active = value === select.value;
        button.disabled = !available;
        button.classList.toggle('is-unavailable', !available);
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        button.setAttribute('aria-label', value + (message ? ' — ' + message : ''));
        button.querySelector('.tt-choice__availability').textContent = message;
        if (!available) unavailableCount++;
      });
      var message = unavailableCount ? 'Crossed-out options are unavailable' + (color ? ' in ' + color.value : '') + '.' : '';
      if (note.textContent !== message) note.textContent = message;
      note.hidden = !message;
    }
    var pending = false;
    function scheduleSync() {
      if (pending) return;
      pending = true;
      Promise.resolve().then(function () { pending = false; sync(); });
    }
    root.addEventListener('change', scheduleSync);
    new MutationObserver(scheduleSync).observe(root, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'selected']
    });
    fieldset.appendChild(choices);
    fieldset.appendChild(note);
    sync();
    return fieldset;
  }

  function tierTitle(category) {
    if (category === 'single') return 'Single Roll';
    if (category === 'case') return 'Full Case / Box';
    if (category === 'pallet') return 'Pallet';
    return 'Pack';
  }

  function renderSplitPicker(root, select, optionName, selects) {
    var parsedValues = Array.prototype.map.call(select.options, function (option) {
      var parsed = parsePack(option.value);
      if (parsed) {
        var variant = variantFor(root, selects, select, option.value);
        parsed.disabled = option.disabled || !variant || !variant.available;
      }
      return parsed;
    });
    if (parsedValues.some(function (item) { return !item; })) return null;

    var specifications = parsedValues.reduce(function (list, item) {
      if (list.indexOf(item.specification) === -1) list.push(item.specification);
      return list;
    }, []);
    var categories = parsedValues.reduce(function (list, item) {
      if (list.indexOf(item.category) === -1) list.push(item.category);
      return list;
    }, []);
    if (specifications.length < 2 || categories.length < 2) return null;

    var wrap = element('div', 'tt-picker__split');
    var sizeFieldset = element('fieldset', 'tt-picker__group');
    addHeading(sizeFieldset, optionName.replace(/size/i, 'Width & Length'));
    var sizeButtons = element('div', 'tt-picker__buttons');
    var packFieldset = element('fieldset', 'tt-picker__group tt-picker__group--packs');
    addHeading(packFieldset, 'Purchase Option');
    var packCards = element('div', 'tt-picker__cards');

    var current = parsePack(select.value) || parsedValues[0];
    var currentSpecification = current.specification;
    var currentCategory = current.category;

    specifications.forEach(function (specification) {
      var button = element('button', 'tt-choice', specification);
      button.type = 'button';
      button.dataset.specification = specification;
      button.disabled = !parsedValues.some(function (item) {
        return item.specification === specification && !item.disabled;
      });
      if (button.disabled) {
        button.classList.add('is-unavailable');
        button.textContent = specification + ' — Sold out';
      }
      button.addEventListener('click', function () {
        if (button.disabled) return;
        currentSpecification = specification;
        var match = parsedValues.find(function (item) {
          return item.specification === currentSpecification && item.category === currentCategory && !item.disabled;
        }) || parsedValues.find(function (item) {
          return item.specification === currentSpecification && !item.disabled;
        });
        if (match) setSelect(select, match.raw);
        renderCards();
        sync();
      });
      sizeButtons.appendChild(button);
    });

    function renderCards() {
      packCards.innerHTML = '';
      parsedValues.filter(function (item) {
        return item.specification === currentSpecification;
      }).forEach(function (item) {
        var button = element('button', 'tt-pack-card');
        button.type = 'button';
        button.dataset.value = item.raw;
        button.disabled = item.disabled;
        button.appendChild(element('span', 'tt-pack-card__title', tierTitle(item.category)));
        button.appendChild(element('span', 'tt-pack-card__detail', item.pack));
        if (item.disabled) {
          button.classList.add('is-unavailable');
          button.appendChild(element('span', 'tt-choice__availability', 'Sold out'));
        }

        var variant = variantFor(root, selects, select, item.raw);
        if (variant) {
          button.appendChild(element('span', 'tt-pack-card__price', money(variant.price)));
          if (item.unitCount && item.unitCount > 1) {
            button.appendChild(element('span', 'tt-pack-card__unit', money(variant.price / item.unitCount) + ' per unit'));
          }
        }

        button.addEventListener('click', function () {
          if (button.disabled) return;
          currentCategory = item.category;
          setSelect(select, item.raw);
          sync();
        });
        packCards.appendChild(button);
      });
    }

    function sync() {
      var selected = parsePack(select.value);
      if (selected) {
        currentSpecification = selected.specification;
        currentCategory = selected.category;
      }
      Array.prototype.forEach.call(sizeButtons.children, function (button) {
        var active = button.dataset.specification === currentSpecification;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      Array.prototype.forEach.call(packCards.children, function (button) {
        var active = button.dataset.value === select.value;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    select.addEventListener('change', function () {
      var next = parsePack(select.value);
      if (next && next.specification !== currentSpecification) {
        currentSpecification = next.specification;
        renderCards();
      }
      sync();
    });

    sizeFieldset.appendChild(sizeButtons);
    packFieldset.appendChild(packCards);
    wrap.appendChild(sizeFieldset);
    wrap.appendChild(packFieldset);
    renderCards();
    sync();
    return wrap;
  }

  function enhance(root) {
    if (root.dataset.ttEnhanced === 'true') return;
    var selects = Array.prototype.slice.call(root.querySelectorAll('select[name^="options["]'));
    if (!selects.length) return;

    root.dataset.ttEnhanced = 'true';
    var custom = element('div', 'tt-picker');
    custom.setAttribute('data-total-tapes-picker', '');

    selects.forEach(function (select, index) {
      var match = select.name.match(/^options\[(.*)\]$/);
      var optionName = match ? match[1] : ('Option ' + (index + 1));
      var control;

      if (/color|colour/i.test(optionName)) {
        control = renderColorPicker(select, optionName);
      } else if (selects.length === 1) {
        control = renderSplitPicker(root, select, optionName, selects) || renderButtonPicker(select, optionName);
      } else {
        control = renderButtonPicker(select, optionName);
      }
      custom.appendChild(control);
    });

    root.parentNode.insertBefore(custom, root);
    // Keep native options usable until the replacement controls are ready.
    root.classList.add('tt-picker-native');
  }

  function safelyEnhance(root) {
    try {
      enhance(root);
    } catch (error) {
      root.classList.remove('tt-picker-native');
      console.warn('Custom product options unavailable; native options retained.', error);
    }
  }

  function init(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(context.querySelectorAll('variant-selects'), safelyEnhance);
  }

  function boot() {
    init(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('variant-selects')) safelyEnhance(node);
          init(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
